@if (institutionId > 0) {
  <div id="submodule-characteristics" class="cw-module-card cwSubModule">
    <!-- Header -->
    <div class="cw-flex-row">
      <h2>{{ 'GENERAL.CHARACTERISTICS' | translate }}</h2>
      <!-- Toolbar für Expand Characteristics Button -->
      <phscw-toolbar
        componentIdentifier="institutionsCharacteristics"
        [componentConnection]="$any(this)"
        [buttonExpandCharacteristics]="true"
        characteristicsOpenState="false">
      </phscw-toolbar>
    </div>
    <!-- Expansion-Panel-Felder -->
    <phscw-characteristic-groups-list
      [entityId]="institutionId"
      [characteristicType]="characteristicType"
      [multi]="multi"
      [showEditButton]="institutionsService.allowEditCombined || ignoreAllowEditCombined">
    </phscw-characteristic-groups-list>
  </div>
}
